import { Controller } from '@hotwired/stimulus';
import { markExtensionInstallPending } from './helpers/extension_install_signal';

export default class extends Controller {
  static targets = ['refreshNotice'];

  showRefreshNotice() {
    setTimeout(() => {
      if (this.hasRefreshNoticeTarget) {
        this.refreshNoticeTarget.classList.remove('d-none');
      }
    }, 1000);
  }

  refreshPage() {
    markExtensionInstallPending();
    window.location.reload();
  }
}
